import React, { useState } from 'react';
import { Bell, BellRing } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthProvider';
import { useTrackedOpportunities } from '../../hooks/useTrackedOpportunities';

const TRACKING_ALERTS = ['Last Date', 'Admit Card', 'Exam Date', 'Answer Key', 'Result'];

export function TrackOpportunityButton({
  opportunityId,
  compact = false,
}: {
  opportunityId: string;
  compact?: boolean;
}) {
  const navigate = useNavigate();
  const { isSignedIn } = useAuth();
  const { isTracked, track, untrack, isPending } = useTrackedOpportunities();
  const [showConfirm, setShowConfirm] = useState(false);
  const tracked = isTracked(opportunityId);

  const handleClick = async () => {
    if (!isSignedIn) {
      navigate('/login');
      return;
    }
    if (tracked) {
      await untrack(opportunityId);
      setShowConfirm(false);
      return;
    }
    await track(opportunityId);
    setShowConfirm(true);
  };

  return (
    <div className="wfx-opp-track-wrap">
      <button
        type="button"
        className={`${compact ? 'secondary-action compact' : 'secondary-action'}${tracked ? ' is-tracked' : ''}`}
        onClick={() => void handleClick()}
        disabled={isPending}
      >
        {tracked ? <BellRing size={16} aria-hidden="true" /> : <Bell size={16} aria-hidden="true" />}
        {tracked ? 'Tracking' : 'Track opportunity'}
      </button>

      {showConfirm && tracked && (
        <div className="wfx-opp-track-confirm glass-surface" role="status">
          <strong>✓ Tracking</strong>
          <p className="wfx-muted">You&apos;ll receive notifications for:</p>
          <ul>
            {TRACKING_ALERTS.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <button type="button" className="text-action" onClick={() => setShowConfirm(false)}>
            Dismiss
          </button>
        </div>
      )}
    </div>
  );
}
